import * as Yup from "yup";

export const tenantSchema = Yup.object().shape({
    tradeName: Yup.string().required("O Noma Fantasia é obrigatório").min(2, "Muito curto"),
    corporateName: Yup.string().nullable(),
    document: Yup.string().nullable(), // CNPJ
    email: Yup.string().email("Digite um e-mail válido").nullable(),
    phone: Yup.string().nullable(),
    website: Yup.string().url("URL inválida").nullable(),
    
    logoUrl: Yup.string().nullable(),
    brandColor: Yup.string().nullable(),

    // Endereço
    zipCode: Yup.string().nullable(),
    address: Yup.string().nullable(),
    number: Yup.string().nullable(),
    complement: Yup.string().nullable(),
    neighborhood: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    country: Yup.string().nullable().default("Brasil"),

    // Representante
    legalRepresentative: Yup.object({
        name: Yup.string().nullable(),
        cpf: Yup.string().nullable(),
        email: Yup.string().email("E-mail inválido").nullable(),
        phone: Yup.string().nullable()
    }).nullable()
});
